module.exports = __webpack_public_path__ + "img/kenya_impact.cb480732.jpg";